import { store } from '@/app/store/store';
import { getRecentActions } from '@/app/store/utils/common';
import { API_BASE_URL } from '@app/shared/constants/api';
import { getViewport } from './get-viewport';
import { getNetworkInfo } from './get-network';
import { getLogData } from './get-log-data';

type LogLevel = 'error' | 'warn' | 'info' | 'trace' | 'debug';

interface FrontendLogData {
  viewport: ReturnType<typeof getViewport>;
  network: ReturnType<typeof getNetworkInfo>;
}

export interface CapturedAction {
  type: string;
  payload?: unknown;
  timestamp: number;
}

interface FrontendReduxLog {
  lastActions: CapturedAction[];
  stateSnapshot: {
    auth?: unknown;
    router?: unknown;
  };
}

interface FrontendLog {
  level: LogLevel;
  environment: string;
  message?: string;
  errMessage?: string;
  stack?: string;
  fileName?: string;
  url: string;
  userAgent: string;
  version: string;
  timestamp: string;
  locale: string;
  timezone: string;
  hardwareConcurrency: number;
  doNotTrack: string | null;
  cookieEnabled: boolean;
  online: boolean;
  data: FrontendLogData;
  redux: FrontendReduxLog;
  extra?: Record<string, unknown>;
}

export async function log({
  message,
  level,
  error,
  extra,
}: {
  level: LogLevel;
  message?: string;
  error?: unknown;
  extra?: Record<string, unknown>;
}) {
  const state = store.getState();
  const lastActions = getRecentActions();

  const logPayload: FrontendLog = {
    level,
    environment: import.meta.env.VITE_APP_ENV as string,
    message,
    errMessage: (error as Error | undefined)?.message,
    stack: (error as Error | undefined)?.stack,
    url: window.location.href,
    userAgent: navigator.userAgent,
    version: `${import.meta.env.VITE_APP_VERSION as string} (${import.meta.env.VITE_GIT_HASH as string})`,
    timestamp: new Date().toISOString(),
    locale: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hardwareConcurrency: navigator.hardwareConcurrency,
    doNotTrack: navigator.doNotTrack,
    cookieEnabled: navigator.cookieEnabled,
    online: navigator.onLine,

    data: {
      ...getLogData(),
      viewport: getViewport(),
      network: getNetworkInfo(),
    },

    redux: {
      lastActions,
      stateSnapshot: {
        auth: state.auth,
      },
    },

    extra,
  };

  try {
    await fetch(`${API_BASE_URL}/log/fe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(logPayload),
    });
  } catch {
    // не ломаем приложение если лог не отправился
  }
}
